export const wizardDialogTitleSlotSx = {
  width: 'auto',
} as const;
